(function($, undefined) {

	'use strict';
	
	var initLogosSlider = function() {
		$('.logos-component-all-logos-inner.slider').each(function() {
			var t = $(this);
			var ctn = t.closest('.logos-component-all-logos-outer');
			var count = t.data('count');
			// console.log(count)

			if (t.closest('.side-nav-content-ctn').length) {
				slickSideNav(t, ctn);
			} else {
				slick(t, ctn);
			}

			ctn.fadeIn();
		});
	};

	var slick = function(t) {
		// console.log('slick')
		if (!t.hasClass('slick-initialized')) {
			t.removeClass('flexbox');
			var max = t.data('max');

			t.slick({
				autoplay: true,
				dots: false,
				arrows: false,
				slide: '.logos-component-one-logo',
				autoplaySpeed: 4000,
				slidesToShow: max,
				slidesToScroll: max,
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: max <= 4 ? max : 4,
							slidesToScroll: max <= 4 ? max : 4,
						}
					},
					{
						breakpoint: 767,
						settings: {
							slidesToShow: max <= 3 ? max : 3,
							slidesToScroll: max <= 3 ? max : 3,
						}
					},
					{
						breakpoint: 599,
						settings: {
							slidesToShow: max <= 2 ? max : 2,
							slidesToScroll: max <= 2 ? max : 2,
						}
					},
					{
						breakpoint: 479,
						settings: {
							slidesToShow: max <= 1 ? max : 1,
							slidesToScroll: max <= 1 ? max : 1,
						}
					}
				]
			});
		}
	};

	var slickSideNav = function(t) {
		// console.log('slick')
		if (!t.hasClass('slick-initialized')) {
			t.removeClass('flexbox');
			var max = t.data('max');

			t.slick({
				autoplay: true,
				dots: false,
				arrows: false,
				slide: '.logos-component-one-logo',
				autoplaySpeed: 4000,
				slidesToShow: max,
				slidesToScroll: max,
				responsive: [
					{
						breakpoint: 1280,
						settings: {
							slidesToShow: max <= 3 ? max : 3,
							slidesToScroll: max <= 3 ? max : 3,
						}
					},
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: max,
							slidesToScroll: max,
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: max <= 3 ? max : 3,
							slidesToScroll: max <= 3 ? max : 3,
						}
					},
					{
						breakpoint: 600,
						settings: {
							slidesToShow: max <= 2 ? max : 2,
							slidesToScroll: max <= 2 ? max : 2,
						}
					},
					{
						breakpoint: 480,
						settings: {
							slidesToShow: max <= 1 ? max : 1,
							slidesToScroll: max <= 1 ? max : 1,
						}
					}
				]
			});
		}
	};

	var unslick = function(t) {
		// console.log('unslick')
		if (t.hasClass('slick-initialized')) {	
			t.slick('unslick');
		}
		t.addClass('flexbox');
	};

	var init = function() {
		if ($('.logos-component-all-logos-inner.slider').length > 0) {		
			initLogosSlider();

			$(window).resize(function() {
				initLogosSlider();
			});
		}
	};
	
	$(window).ready(function () {
		init();
	});

})(jQuery);

